/**
 * Legacy knowledge-graph explorer — pipeline-owned graphs plus document sets.
 *
 * This used to be a full ~2.4k-line copy of `/knowledge-graphs`. The two had
 * already drifted (the fix for the pipeline-only query gate landed in one and
 * not the other), so it is now a thin wrapper over the same
 * `KnowledgeGraphsView`. The only difference from the primary page is that
 * this one still offers pipelines in the owner picker.
 *
 * Reachable from the nav's Legacy folder.
 */

import { createFileRoute } from '@tanstack/react-router';

import { KnowledgeGraphsView, type IKgRouteSearch } from '../knowledge-graphs';

export const Route = createFileRoute('/internal/knowledge-graphs')({
  component: LegacyKnowledgeGraphsPage,
  validateSearch: (raw: Record<string, unknown>): IKgRouteSearch => {
    const out: IKgRouteSearch = {};
    if (raw.ownerKind === 'pipeline' || raw.ownerKind === 'documentSet') {
      out.ownerKind = raw.ownerKind;
    }
    if (typeof raw.ownerId === 'string') out.ownerId = raw.ownerId;
    const v = typeof raw.kgVersion === 'string' ? Number(raw.kgVersion) : raw.kgVersion;
    if (typeof v === 'number' && Number.isFinite(v)) out.kgVersion = v;
    return out;
  },
});

function LegacyKnowledgeGraphsPage() {
  const search = Route.useSearch();
  return <KnowledgeGraphsView search={search} ownerKinds={['pipeline', 'documentSet']} />;
}
